export default __webpack_public_path__ + "static/media/ico-file-cpf.c38fcee2.svg";